import React from 'react'
import moment from 'moment'
import { Box, Typography } from '@mui/material'

/**
 * Who created and last edited a company, placed under a dialog title. Rendered beside DialogTitle,
 * not inside it, because DialogTitle is the dialog's accessible name.
 */
export const AuditSubtitle = ({ company }) => (
  <Box sx={{ px: 3, pb: 2, mt: -2 }}>
    <Typography variant='caption' color='text.secondary' display='block'>
      Created by {company.createdBy.name} · {moment(company.createdAt).format('h:mm a, DD/MM/YYYY')}
    </Typography>
    <Typography variant='caption' color='text.secondary' display='block'>
      Last edited by {company.updatedBy.name} ·{' '}
      {moment(company.updatedAt).format('h:mm a, DD/MM/YYYY')}
    </Typography>
  </Box>
)
